module.exports = require("canvas");